import { getFromBrandConfig } from 'brand-config';

// eslint-disable-next-line import/prefer-default-export
export function getBrandVaultProject() {
  return getFromBrandConfig('vaultProject');
}
